import { useEffect, useState } from "react";

import { EditableFile, LinkButton } from "ui";
import { ReactComponent as DownloadIcon } from "images/downloadIcon.svg";
import { downloadFileBlob } from "utils";

interface Props {
  endpoint: string;
  fileNameStatic?: string;
  tooltip?: string;
  id?: string;
}

export const ButtonDownload: React.FC<Props> = ({ endpoint, fileNameStatic, tooltip, id }) => {
  const [urlFile, setUrlFile] = useState<string>();
  const [fileName, setFileName] = useState<string>(fileNameStatic || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getFile = async () => {
      setLoading(true);
      try {
        const { filename, url } = await downloadFileBlob(endpoint);
        setFileName(filename);
        setUrlFile(url);
      } catch (e) {
        console.error("Error downloading file", e);
      } finally {
        setLoading(false);
      }
    };
    getFile();
  }, [endpoint]);

  if (!urlFile) return null;
  return tooltip ? (
    <EditableFile
      file={{
        url: urlFile,
        docName: fileName,
      }}
      tooltip={tooltip}
    />
  ) : (
    <LinkButton icon={<DownloadIcon />} href={urlFile} download={fileName} id={id} disabled={loading}>
      {fileName}
    </LinkButton>
  );
};
